import { render, staticRenderFns } from "./incidentReportTable.vue?vue&type=template&id=5b05dcb2"
import script from "./incidentReportTable.vue?vue&type=script&lang=js"
export * from "./incidentReportTable.vue?vue&type=script&lang=js"
import style0 from "./incidentReportTable.vue?vue&type=style&index=0&id=5b05dcb2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports